import React, { Fragment } from 'react';

function getDesign(messageListPwdChange) {

  return (
    <Fragment>
      <div className="hdg-guide">
        <h2 className="hdg-guide_txt">{messageListPwdChange.M013_notices}</h2>
      </div>
      <ul className="list">
        <li>{messageListPwdChange.M020_noticeJohn001}<br></br>{messageListPwdChange.M021_noticeJohn002}</li>
      </ul>
    </Fragment>
  );
}

export { getDesign }